"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContainer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _TableContainer = require("./TableContainer.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _excluded = ["responsive", "stickyHeader"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Wrap your table in the TableContainer component to enable responsive behavior and/or sticky headers.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablecontainer--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table#container) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableContainer)
 */
var TableContainer = exports.TableContainer = function TableContainer(_ref) {
  var responsive = _ref.responsive,
    stickyHeader = _ref.stickyHeader,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSticky = _useState2[0],
    setSticky = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_TableContainer.Container, Object.assign({
    $responsive: responsive,
    $stickyHeader: stickyHeader,
    onScroll: function onScroll(e) {
      return setSticky(e.target instanceof HTMLElement && e.target.scrollTop !== 0);
    },
    $isSticky: isSticky
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TableContainer
  }));
};